import { gql } from '@apollo/client';
import apolloClient from '../lib/apollo-client';
import { LoginResponse, RegisterResponse } from '../features/auth/types';
import { setCookie } from '../utils/cookies';

// Make sure this mutation is defined in your mutations.ts file
// If not, you'll need to add it there
import { 
  LOGIN_MUTATION, 
  REGISTER_MUTATION, 
  FORGOT_PASSWORD_MUTATION, 
  RESET_PASSWORD_MUTATION
} from '@/lib/graphql/mutations';


export const login = async (credentials: { email: string; password: string }): Promise<LoginResponse> => {
  try {
    console.log('credentials', credentials);
    const { data } = await apolloClient.mutate({
      mutation: LOGIN_MUTATION,
      variables: { input: credentials },
    });

    if (data.login.error) {
      throw new Error(data.login.error);
    }

    return data.login;
  } catch (error) {
    throw error;
  }
};

export const register = async (credentials: { email: string; password: string }): Promise<RegisterResponse> => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: REGISTER_MUTATION,
      variables: { input: credentials },
    });

    if (data.register.error) {
      throw new Error(data.register.error);
    }

    return data.register;
  } catch (error) {
    throw error;
  }
};

export interface ForgotPasswordResponse {
  success: boolean;
  message: string;
  statusCode: number;
  error: string | null;
}

export const forgotPassword = async (email: string): Promise<ForgotPasswordResponse> => {
  try {
    console.log('Requesting password reset for:', email);
    const { data } = await apolloClient.mutate({
      mutation: FORGOT_PASSWORD_MUTATION,
      variables: { input: { email } },
    });

    if (data.forgotPassword.error) {
      throw new Error(data.forgotPassword.error);
    }

    return data.forgotPassword;
  } catch (error) {
    console.error('Forgot password error:', error);
    throw error;
  }
};

// Add this interface and function to your authService.ts file

export interface ResetPasswordResponse {
  success: boolean;
  message: string;
  statusCode: number;
  error: string | null;
}

export const resetPassword = async (token: string, newPassword: string): Promise<ResetPasswordResponse> => {
  try {
    console.log('Resetting password with token');
    const { data } = await apolloClient.mutate({
      mutation: RESET_PASSWORD_MUTATION,
      variables: { 
        input: { 
          token, 
          newPassword 
        } 
      },
    });

    if (data.resetPassword.error) {
      throw new Error(data.resetPassword.error);
    }

    return data.resetPassword;
  } catch (error) {
    console.error('Reset password error:', error);
    throw error;
  }
};